// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.About_pg_section {
  position: relative;
  padding: 116px 6vw;
  background: #F5F7F5;
  overflow: hidden;
}

.About_pg_row {
  position: relative;
  z-index: 1;
  max-width: 1180px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 64px;
  align-items: center;
}

.About_pg_col_text {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

/* ---------- Heading ---------- */

.About_pg_heading {
  font-family: Georgia, serif;
  font-weight: 600;
  font-size: clamp(2.1rem, 3.4vw + 0.5rem, 3rem);
  line-height: 1.12;
  letter-spacing: -0.01em;
  color: #8d0381;
  margin: 0;
}

.About_pg_heading_accent {
  position: relative;
  font-style: italic;
  color: #01530f;
  white-space: nowrap;
}

.About_pg_heading_accent::after {
  content: "";
  position: absolute;
  left: -2px;
  right: -2px;
  bottom: 2px;
  height: 3px;
  background-image: linear-gradient(to right, rgb(72, 255, 0) , rgb(255, 0, 200));
  z-index: -1;

}

/* ---------- Paragraphs ---------- */

.About_pg_paragraph {
  font-size: 1.2rem;
  line-height: 1.75;
  color: #3A4A4C;
  margin: 0;
  max-width: 54ch;
  text-align: justify;
}

/* ---------- Checklist ---------- */

.About_pg_list {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.About_pg_list_item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  font-size: 1rem;
  line-height: 1.5;
  color: #223234;
  padding: 4px 0;
}

.About_pg_list_icon {
  flex: 0 0 auto;
  width: 26px;
  height: 26px;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 700;
  color: #FFFFFF;
  transform: rotate(-4deg);
  transition: transform 0.25s ease;
}

.About_pg_list_item:hover .About_pg_list_icon {
  transform: rotate(0deg) scale(1.08);
}

.About_pg_list_icon_teal   { background: #1F7A6C; }
.About_pg_list_icon_gold   { background: #C98A1F; }
.About_pg_list_icon_blue   { background: #2E5C8A; }

/* ---------- Stat chips ---------- */

.About_pg_stats_row {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 12px;
}

.About_pg_stat_chip {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 20px;
  border-radius: 12px;
  background-image: linear-gradient(to right, rgba(167, 0, 111, 0.651) , rgb(213, 255, 185));
  box-shadow: 0 2px 0 rgba(27, 42, 46, 0.04);
  min-width: 104px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}


.About_pg_stat_num {
  font-family: monospace;
  font-size: 1.35rem;
  font-weight: 700;
  color: #000000;
}

.About_pg_stat_label {
  font-size: 0.78rem;

  text-transform: uppercase;
  color: #000000;
}

.About_pg_stat_chip_teal .About_pg_stat_num { color: #1F7A6C; }
.About_pg_stat_chip_gold .About_pg_stat_num { color: #C98A1F; }
.About_pg_stat_chip_blue .About_pg_stat_num { color: #2E5C8A; }

/* ---------- Image ---------- */

.About_pg_col_image {
  display: flex;
  justify-content: center;
}

.About_pg_image_frame {
  position: relative;
  width: 100%;
  max-width: 460px;
  border-radius: 18px;
  padding: 14px;
  background: #0b4906;

}

.About_pg_image_frame::before {
  content: "";
  position: absolute;
  inset: -10px;
  border-radius: 22px;
  pointer-events: none;
}

.About_pg_image {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 10px;
  object-fit: cover;
}

/* ==========================================================================
   Responsive breakpoints
   ========================================================================== */

/* Tablets */
@media (max-width: 1024px) {
  .About_pg_section {
    padding: 80px 5vw;
  }

  .About_pg_row {
    gap: 48px;
  }

  .About_pg_image_frame {
    max-width: 400px;
  }
}

/* Small tablets / large phones */
@media (max-width: 860px) {
  .About_pg_section::before {
    display: none;
  }

  .About_pg_row {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .About_pg_col_image {
    order: -1;
  }

  .About_pg_image_frame {
    max-width: 420px;
    margin: 0 auto;
  }

  .About_pg_paragraph {
    max-width: none;
  }
}

/* Phones (including Android) */
@media (max-width: 560px) {
  .About_pg_section {
    padding: 56px 6vw 64px;
  }

  .About_pg_heading {
    font-size: clamp(1.7rem, 6vw, 2.2rem);
    line-height: 1.2;
  }

  .About_pg_paragraph {
    font-size: 0.98rem;
    line-height: 1.65;
  }

  .About_pg_list {
    gap: 12px;
  }

  .About_pg_list_item {
    font-size: 0.95rem;
    gap: 12px;
  }

  .About_pg_list_icon {
    width: 24px;
    height: 24px;
    font-size: 0.78rem;
  }

  .About_pg_stats_row {
    gap: 10px;
  }

  .About_pg_stat_chip {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    min-width: 0;
    padding: 10px 14px;
    align-items: flex-start;
  }

  .About_pg_image_frame {
    max-width: 100%;
    padding: 10px;
    border-radius: 16px;
  }

  .About_pg_image_frame::before {
    inset: -8px;
    border-radius: 20px;
  }
}

/* Extra small phones */
@media (max-width: 380px) {
  .About_pg_section {
    padding: 44px 5vw 52px;
  }

  .About_pg_heading {
    font-size: 1.55rem;
  }

  .About_pg_stat_chip {
    flex: 1 1 100%;
  }
}

/* Respect reduced motion preference */
@media (prefers-reduced-motion: reduce) {
  .About_pg_list_icon,
  .About_pg_stat_chip {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/AboutPage/AboutPage.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kCAAkC;;AAElC;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,8CAA8C;EAC9C,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,+EAA+E;EAC/E,WAAW;;AAEb;;AAEA,qCAAqC;;AAErC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA,oCAAoC;;AAEpC;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,mBAAmB,EAAE;;AAElD,qCAAqC;;AAErC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,0FAA0F;EAC1F,0CAA0C;EAC1C,gBAAgB;EAChB,uDAAuD;AACzD;;;AAGA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;;EAElB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,8CAA8C,cAAc,EAAE;AAC9D,8CAA8C,cAAc,EAAE;AAC9D,8CAA8C,cAAc,EAAE;;AAE9D,gCAAgC;;AAEhC;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;+EAE+E;;AAE/E,YAAY;AACZ;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,sCAAsC;AACtC;EACE;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["\n.About_pg_section {\n  position: relative;\n  padding: 116px 6vw;\n  background: #F5F7F5;\n  overflow: hidden;\n}\n\n.About_pg_row {\n  position: relative;\n  z-index: 1;\n  max-width: 1180px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1.05fr 0.95fr;\n  gap: 64px;\n  align-items: center;\n}\n\n.About_pg_col_text {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n}\n\n/* ---------- Heading ---------- */\n\n.About_pg_heading {\n  font-family: Georgia, serif;\n  font-weight: 600;\n  font-size: clamp(2.1rem, 3.4vw + 0.5rem, 3rem);\n  line-height: 1.12;\n  letter-spacing: -0.01em;\n  color: #8d0381;\n  margin: 0;\n}\n\n.About_pg_heading_accent {\n  position: relative;\n  font-style: italic;\n  color: #01530f;\n  white-space: nowrap;\n}\n\n.About_pg_heading_accent::after {\n  content: \"\";\n  position: absolute;\n  left: -2px;\n  right: -2px;\n  bottom: 2px;\n  height: 3px;\n  background-image: linear-gradient(to right, rgb(72, 255, 0) , rgb(255, 0, 200));\n  z-index: -1;\n\n}\n\n/* ---------- Paragraphs ---------- */\n\n.About_pg_paragraph {\n  font-size: 1.2rem;\n  line-height: 1.75;\n  color: #3A4A4C;\n  margin: 0;\n  max-width: 54ch;\n  text-align: justify;\n}\n\n/* ---------- Checklist ---------- */\n\n.About_pg_list {\n  list-style: none;\n  margin: 8px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.About_pg_list_item {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #223234;\n  padding: 4px 0;\n}\n\n.About_pg_list_icon {\n  flex: 0 0 auto;\n  width: 26px;\n  height: 26px;\n  border-radius: 7px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #FFFFFF;\n  transform: rotate(-4deg);\n  transition: transform 0.25s ease;\n}\n\n.About_pg_list_item:hover .About_pg_list_icon {\n  transform: rotate(0deg) scale(1.08);\n}\n\n.About_pg_list_icon_teal   { background: #1F7A6C; }\n.About_pg_list_icon_gold   { background: #C98A1F; }\n.About_pg_list_icon_blue   { background: #2E5C8A; }\n\n/* ---------- Stat chips ---------- */\n\n.About_pg_stats_row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin-top: 12px;\n}\n\n.About_pg_stat_chip {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 12px 20px;\n  border-radius: 12px;\n  background-image: linear-gradient(to right, rgba(167, 0, 111, 0.651) , rgb(213, 255, 185));\n  box-shadow: 0 2px 0 rgba(27, 42, 46, 0.04);\n  min-width: 104px;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n\n.About_pg_stat_num {\n  font-family: monospace;\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #000000;\n}\n\n.About_pg_stat_label {\n  font-size: 0.78rem;\n\n  text-transform: uppercase;\n  color: #000000;\n}\n\n.About_pg_stat_chip_teal .About_pg_stat_num { color: #1F7A6C; }\n.About_pg_stat_chip_gold .About_pg_stat_num { color: #C98A1F; }\n.About_pg_stat_chip_blue .About_pg_stat_num { color: #2E5C8A; }\n\n/* ---------- Image ---------- */\n\n.About_pg_col_image {\n  display: flex;\n  justify-content: center;\n}\n\n.About_pg_image_frame {\n  position: relative;\n  width: 100%;\n  max-width: 460px;\n  border-radius: 18px;\n  padding: 14px;\n  background: #0b4906;\n\n}\n\n.About_pg_image_frame::before {\n  content: \"\";\n  position: absolute;\n  inset: -10px;\n  border-radius: 22px;\n  pointer-events: none;\n}\n\n.About_pg_image {\n  display: block;\n  width: 100%;\n  height: auto;\n  border-radius: 10px;\n  object-fit: cover;\n}\n\n/* ==========================================================================\n   Responsive breakpoints\n   ========================================================================== */\n\n/* Tablets */\n@media (max-width: 1024px) {\n  .About_pg_section {\n    padding: 80px 5vw;\n  }\n\n  .About_pg_row {\n    gap: 48px;\n  }\n\n  .About_pg_image_frame {\n    max-width: 400px;\n  }\n}\n\n/* Small tablets / large phones */\n@media (max-width: 860px) {\n  .About_pg_section::before {\n    display: none;\n  }\n\n  .About_pg_row {\n    grid-template-columns: 1fr;\n    gap: 40px;\n  }\n\n  .About_pg_col_image {\n    order: -1;\n  }\n\n  .About_pg_image_frame {\n    max-width: 420px;\n    margin: 0 auto;\n  }\n\n  .About_pg_paragraph {\n    max-width: none;\n  }\n}\n\n/* Phones (including Android) */\n@media (max-width: 560px) {\n  .About_pg_section {\n    padding: 56px 6vw 64px;\n  }\n\n  .About_pg_heading {\n    font-size: clamp(1.7rem, 6vw, 2.2rem);\n    line-height: 1.2;\n  }\n\n  .About_pg_paragraph {\n    font-size: 0.98rem;\n    line-height: 1.65;\n  }\n\n  .About_pg_list {\n    gap: 12px;\n  }\n\n  .About_pg_list_item {\n    font-size: 0.95rem;\n    gap: 12px;\n  }\n\n  .About_pg_list_icon {\n    width: 24px;\n    height: 24px;\n    font-size: 0.78rem;\n  }\n\n  .About_pg_stats_row {\n    gap: 10px;\n  }\n\n  .About_pg_stat_chip {\n    flex: 1 1 calc(50% - 10px);\n    min-width: 0;\n    padding: 10px 14px;\n    align-items: flex-start;\n  }\n\n  .About_pg_image_frame {\n    max-width: 100%;\n    padding: 10px;\n    border-radius: 16px;\n  }\n\n  .About_pg_image_frame::before {\n    inset: -8px;\n    border-radius: 20px;\n  }\n}\n\n/* Extra small phones */\n@media (max-width: 380px) {\n  .About_pg_section {\n    padding: 44px 5vw 52px;\n  }\n\n  .About_pg_heading {\n    font-size: 1.55rem;\n  }\n\n  .About_pg_stat_chip {\n    flex: 1 1 100%;\n  }\n}\n\n/* Respect reduced motion preference */\n@media (prefers-reduced-motion: reduce) {\n  .About_pg_list_icon,\n  .About_pg_stat_chip {\n    transition: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
